// src/hooks/useSliderInterface.js
import { useEffect } from "react";
export const useSliderInterface = () => {
  useEffect(() => {
    const id = setInterval(() => {
      if (window.jQuery && window.initSliderInterface) {
        window.initSliderInterface();
        clearInterval(id);
      }
    }, 300);
    return () => clearInterval(id);
  }, []);
};
export default useSliderInterface;
